import { useRouteError } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Component } from 'react'
import './CustomErrorBoundary.css'

// Class component for React error boundary
class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorUI error={this.state.error} />
    }

    return this.props.children
  }
}

// Separate UI component for displaying errors
const ErrorUI = ({ error }) => {
  return (
    <div className="error-container">
      <div className="glitch-wrapper">
        <div className="glitch" data-text="Error">
          Error
        </div>
      </div>
      <h2 className="subtitle">Something went wrong</h2>
      <p className="error-message">{error?.message || 'An unexpected error occurred'}</p>
      <div className="button-container">
        <button className="retry-button" onClick={() => window.location.reload()}>
          Reload Page
        </button>
        <button className="home-button" onClick={() => (window.location.href = '/')}>
          Go Home
        </button>
      </div>
    </div>
  )
}

// Router error boundary component
const RouterErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    if (error) {
      Sentry.captureException(error)
    }
  }, [error])

  return <ErrorUI error={error} />
}

// Export both boundaries
export { RouterErrorBoundary, ErrorBoundary as default }
